/** OmniLight3D parser: the Light3D surface plus range, attenuation and shadow mode. */
import { parseNode3D } from '../../../base/node3d/parser';
import { parsePositionalLightProperties } from '../shared/parser';
import { floatOr, parseOptionalInt } from '../../../../parser/valueParsers';
import { LIGHT_3D_DEFAULTS } from '../../../../godot/scene/light';
export function parseOmniLight3D(heading, properties) {
    const node3dProps = parseNode3D(heading, properties);
    const baseLightProps = parsePositionalLightProperties(properties);
    return {
        ...node3dProps,
        ...baseLightProps,
        omni_range: floatOr(properties.omni_range, LIGHT_3D_DEFAULTS.range, 'omni_range'),
        omni_attenuation: floatOr(properties.omni_attenuation, LIGHT_3D_DEFAULTS.attenuation, 'omni_attenuation'),
        omni_shadow_mode: parseOptionalInt(properties.omni_shadow_mode),
    };
}
//# sourceMappingURL=parser.js.map